import { all, call, put, takeLatest } from "redux-saga/effects";
import { normalize, schema } from "normalizr";
import { getErrorMessage } from "utils/sagasErrorHandler";
import {
    getObjectStructuresEntities,
    getObjectStructuresSuccess,
    getObjectStructuresError,
} from "modules/ObjectStructures/services/Entities/actions";
import { getObjectStructuresRequest } from "modules/ObjectStructures/services/Entities/api";

const objectStructuresSchema = new schema.Entity("object_structures", {},{ idAttribute: (value) => `${value.receiver_code}_${value.code}` });
const objectStructuresListSchema = new schema.Array(objectStructuresSchema);

function* handleGetObjectStructuresEntities ({ payload }) {
    try {
        const { object_structures, count } = yield call(getObjectStructuresRequest, payload);
        const { result, entities } = normalize(object_structures, objectStructuresListSchema);
        yield put(getObjectStructuresSuccess({
            entities: entities.object_structures,
            codes: result,
            count
        }));
    } catch (error) {
        yield put(getObjectStructuresError());
        getErrorMessage(error);
    }
}

// Watchers
export function* objectStructuresEntriesSagas() {
    yield all([
        yield takeLatest(getObjectStructuresEntities, handleGetObjectStructuresEntities),
    ]);
}
